import { render, staticRenderFns } from "./Iconos.vue?vue&type=template&id=1236db36&scoped=true&"
import script from "./Iconos.vue?vue&type=script&lang=js&"
export * from "./Iconos.vue?vue&type=script&lang=js&"
import style0 from "./Iconos.vue?vue&type=style&index=0&id=1236db36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1236db36",
  null
  
)

export default component.exports